import { render } from "./answerRecord.vue?vue&type=template&id=aaf8ae98&scoped=true"
import script from "./answerRecord.vue?vue&type=script&lang=js"
export * from "./answerRecord.vue?vue&type=script&lang=js"

import "./answerRecord.vue?vue&type=style&index=0&id=aaf8ae98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf8ae98"]])

export default __exports__